import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

function SuperAdminRoute({
  component: Component,
  isAuthenticated,
  isSuperAdmin,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={props => {
        return (isAuthenticated && isSuperAdmin ? <Component {...props} /> : (
          <Redirect to="/admin/login" />
        ))
      }}
    />
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: !!state.app.user,
  isSuperAdmin: (!!state.app.user &&
                 state.app.user.isSuperAdmin),
});

export default connect(mapStateToProps)(SuperAdminRoute);
